import type * as z from "zod";
import { searchInputOf, searchResultOf } from "../search";

// What procurement finds (ADR-117). Each type needs the permission of its list, and the same one opens it in the app.

export const procurementSearchTypes = ["purchase_order"] as const;
export type ProcurementSearchType = (typeof procurementSearchTypes)[number];

export const procurementSearchPermissions = {
  purchase_order: "purchase_order.read",
} as const satisfies Record<ProcurementSearchType, string>;

export const searchProcurementInput = searchInputOf(procurementSearchTypes);
export type SearchProcurementInput = z.input<typeof searchProcurementInput>;

export const procurementSearchDto = searchResultOf(procurementSearchTypes).meta({ id: "ProcurementSearch" });
export type ProcurementSearch = z.output<typeof procurementSearchDto>;
